export const isNativeApp = () =>
  !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());

const plugin = () =>
  window.Capacitor && window.Capacitor.Plugins ? window.Capacitor.Plugins.NativeSensors : null;

export const hasNativeSensors = () => isNativeApp() && !!plugin();

export async function collectNativeSensor(sensorType, durationMs, onValue) {
  const p = plugin();
  if (!p) throw new Error("Nativer Sensor nicht verfügbar");
  const avail = await p.isAvailable({ sensor: sensorType }).catch(() => ({ available: false }));
  if (!avail.available) throw new Error("Sensor auf diesem Gerät nicht vorhanden");
  const values = [];
  const sub = await p.addListener("reading", (d) => {
    if (d.sensor === sensorType && typeof d.value === "number") {
      values.push(d.value);
      onValue(d.value);
    }
  });
  await p.start({ sensor: sensorType });
  await new Promise((r) => setTimeout(r, durationMs));
  await p.stop({ sensor: sensorType });
  sub.remove();
  return values;
}
